import { render, staticRenderFns } from "./agregaOportunidaNaturalB2C.vue?vue&type=template&id=16226683&scoped=true"
import script from "./agregaOportunidaNaturalB2C.vue?vue&type=script&lang=js"
export * from "./agregaOportunidaNaturalB2C.vue?vue&type=script&lang=js"
import style0 from "./agregaOportunidaNaturalB2C.vue?vue&type=style&index=0&id=16226683&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16226683",
  null
  
)

export default component.exports